/** WebRTC leak probe for the System tab. Gathers ICE candidates against a STUN
 *  server and reports the server-reflexive (public) IP the browser exposes.
 *  A mismatch with the API-reported public IP is a WebRTC leak. */

export async function webrtcPublicIp(timeoutMs = 2500): Promise<string | null> {
  if (typeof RTCPeerConnection === "undefined") return null;
  return new Promise((resolve) => {
    let settled = false;
    const done = (ip: string | null) => {
      if (settled) return;
      settled = true;
      try { pc.close(); } catch { /* noop */ }
      resolve(ip);
    };

    const pc = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.cloudflare.com:3478" }],
    });
    pc.createDataChannel("probe");
    pc.onicecandidate = (e) => {
      if (!e.candidate) return;
      const m = /([0-9]{1,3}(?:\.[0-9]{1,3}){3})/.exec(e.candidate.candidate);
      if (m && e.candidate.candidate.includes("srflx")) done(m[1]!);
    };
    pc.createOffer().then((o) => pc.setLocalDescription(o)).catch(() => done(null));
    setTimeout(() => done(null), timeoutMs);
  });
}
